/* eslint-disable no-empty */
import {
  HolidayWithGyms,
  LocationClosure,
  RequestBasePostLocationClosure,
  ResponseBasePostLocationClosure,
} from '@hefe/models';
import { createApi } from '@reduxjs/toolkit/query/react';
import API from '../../../api/api';

export const locationClosuresApi = createApi({
  reducerPath: 'locationClosuresApi',
  baseQuery: API.baseQuery,
  endpoints: (builder) => ({
    /**************************************************************************
     *                              ARTICLES
     *************************************************************************/
    fetchLocationClosures: builder.query<LocationClosure[], void>({
      query: (request) => 'location-closures',
    }),
    fetchHolidays: builder.query<HolidayWithGyms[], { until?: string }>({
      query: (request) =>
        `location-closures/holidays?${
          request?.until ? `until=${request.until}` : ''
        }`,
    }),
    createOrUpdateLocationClosure: builder.mutation<
      ResponseBasePostLocationClosure,
      RequestBasePostLocationClosure
    >({
      query: (request) => ({
        url: 'location-closures',
        method: 'POST',
        body: request,
      }),
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        try {
          const { data: responseData } = await queryFulfilled;
          dispatch(
            locationClosuresApi.util.updateQueryData(
              'fetchLocationClosures',
              undefined,
              (draft) => {
                // check if response id is already in the list
                const existingClosure = draft?.find(
                  (closure) => closure.id === responseData.id
                );
                if (existingClosure) {
                  Object.assign(existingClosure, responseData);
                } else {
                  // add new schedule
                  draft?.push(responseData);
                }
              }
            )
          );
        } catch (error: unknown) {}
      },
    }),
    createMultipleLocationClosures: builder.mutation<
      LocationClosure[],
      RequestBasePostLocationClosure[]
    >({
      query: (request) => ({
        url: 'location-closures/multiple',
        method: 'POST',
        body: request,
      }),
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        try {
          const { data: responseData } = await queryFulfilled;
          dispatch(
            locationClosuresApi.util.updateQueryData(
              'fetchLocationClosures',
              undefined,
              (draft) => responseData
            )
          );
        } catch (error: unknown) {}
      },
    }),
    deleteLocationClosure: builder.mutation<void, LocationClosure>({
      query: (request) => ({
        url: `location-closures/${request.id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(request, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            locationClosuresApi.util.updateQueryData(
              'fetchLocationClosures',
              undefined,
              (draft) => draft.filter((closure) => closure.id !== request.id)
            )
          );
        } catch (error: unknown) {}
      },
    }),
  }), // end of endpoints
});

// Export hooks for usage in functional components
export const {
  useFetchLocationClosuresQuery,
  useLazyFetchHolidaysQuery,
  useCreateOrUpdateLocationClosureMutation,
  useCreateMultipleLocationClosuresMutation,
  useDeleteLocationClosureMutation,
  reducerPath,
  reducer,
  middleware,
} = locationClosuresApi;
